import { ReportProfileAlertBaseModel } from '../profile/report-profile-alert-base-model';
import { ReportProfileDeviceModel } from '../profile/report-profile-device-model';
import { ReportProfileDeviceSyncModel } from '../profile/report-profile-device-sync-model';

export class UserReportProfileAlertDevicesModel extends ReportProfileAlertBaseModel {
  invalidDevices: ReportProfileDeviceModel[];
  invalidNotRegisteredDevices: ReportProfileDeviceSyncModel[];
}
